import { Backdrop, Box, Button, Chip, Fade, Grid, LinearProgress, Modal, Paper, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useLang } from '../../../language';
import { InputText } from '../../../components/Inputs/InputText';
import { useForm } from '../../../hooks/useForm';
import { PersonasServices } from '../controllers/services/personas.services';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCheck } from '@fortawesome/free-solid-svg-icons';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 680,
    maxWidth: '95%',
    maxHeight: '92vh',
    display: 'flex',
    flexDirection: 'column' as 'column',
    overflowY: 'auto',
    overflowX: 'hidden',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 3,
};

const DetailField = ({ label, value }: any) => (
    <Box>
        <Typography variant='caption' className='mb-0' sx={{ color: 'text.secondary' }}>
            {label}
        </Typography>
        <Typography variant='body2' className='my-0 fw-500' sx={{ wordBreak: 'break-word' }}>
            {value || '-'}
        </Typography>
    </Box>
)

const nombreCompleto = (item: any = {}) => [item.nombre, item.apellidos].filter(Boolean).join(' ').trim()

export const ModalBuscarPersona = ({ open, onClose, onAutorizar, empresaId }: any) => {

    const Lang = useLang()

    const [formBusqueda, handleInputBusqueda] = useForm({
        termino: '',
    })

    const [personaSeleccionada, setPersonaSeleccionada] = useState<any>(null)

    const [fetchBuscarGET, fetchBuscarGETData, resetBuscarGET] = PersonasServices.GET_BUSCAR_PERSONA()

    useEffect(() => {

        if (open) {

            resetBuscarGET()
            setPersonaSeleccionada(null)
        }

    }, [open])

    const handleBuscar = (e?: any) => {

        if (e) e.preventDefault()

        setPersonaSeleccionada(null)

        // GET /integra-web/empresas/personas/buscar-persona
        fetchBuscarGET({
            params: {
                // El backend busca en `usuarios_ebcn` por el parámetro `q`
                // (NIF, nombre, apellidos o email) excluyendo las asignadas a la empresa
                q: formBusqueda.termino,
                empresa_id: empresaId,
            }
        })
    }

    const items = fetchBuscarGETData.data?.items || []

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-buscar-persona"
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 200,
            }}
        >
            <Fade in={open}>

                <Grid container spacing={1} sx={style} className='z-depth-4'>
                    <Grid item xs={12}>
                        <section className='ModalHeader border-0'>
                            <Typography variant="h6" component="h2">
                                {Lang('BUSCAR_AUTORIZAR_PERSONA')}
                            </Typography>
                        </section>
                    </Grid>

                    <Grid item xs={12}>
                        <section className='ModalBody'>

                            <Box component="form" onSubmit={handleBuscar}>

                                <Grid container spacing={1} alignItems='center'>

                                    <Grid item xs={12} sm={8}>
                                        <InputText
                                            label={Lang('BUSCAR_NOMBRE_NIF')}
                                            name='termino'
                                            value={formBusqueda.termino}
                                            onChange={handleInputBusqueda}
                                        />

                                        <Typography variant='caption' className='my-0' sx={{ color: 'text.secondary' }}>
                                            {Lang('BUSCAR_PERSONA_DESCRIPCION')}
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={4}>
                                        <Button
                                            type="submit"
                                            size="small"
                                            color="primary"
                                            variant="contained"
                                            disabled={fetchBuscarGETData.loading}
                                        >
                                            {Lang('REALIZAR_BUSQUEDA')}
                                        </Button>
                                    </Grid>

                                </Grid>

                            </Box>

                            {
                                fetchBuscarGETData.loading &&
                                <LinearProgress className='mt-2' />
                            }

                        </section>
                    </Grid>

                    <Grid item xs={12} className='mt-2' sx={{ flex: '1 1 auto', minHeight: 0, minWidth: 0, maxHeight: '50vh', overflowY: 'auto', overflowX: 'hidden', pr: 0.5 }}>

                        {
                            items.length > 0 &&

                            <Box>
                                <Typography variant='body2' className='my-0 mb-1' sx={{ color: 'text.secondary' }}>
                                    {Lang('SELECCIONA_UNA_PERSONA')}
                                </Typography>

                                {
                                    items.map((item: any) => (
                                        <Paper
                                            key={item.id}
                                            className='mb-2'
                                            onClick={() => setPersonaSeleccionada(item)}
                                            sx={{
                                                cursor: 'pointer',
                                                border: personaSeleccionada?.id === item.id ? '2px solid var(--color-primary)' : '1px solid rgba(0, 0, 0, 0.12)',
                                                borderRadius: 1,
                                            }}
                                        >
                                            <Box className='p-2'>

                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, minWidth: 0 }}>
                                                    <Typography variant='body1' className='fw-500 my-0' sx={{ wordBreak: 'break-word', minWidth: 0 }}>
                                                        {nombreCompleto(item) || item.username}
                                                    </Typography>

                                                    {
                                                        item.nif &&
                                                        <Chip label={item.nif} size='small' variant="outlined" />
                                                    }
                                                </Box>

                                                <Box sx={{ display: 'flex', flexWrap: 'wrap', columnGap: 2, rowGap: 0.25, mt: 0.5, minWidth: 0, wordBreak: 'break-word' }}>
                                                    {
                                                        item.email &&
                                                        <Typography variant='body2' className='my-0'>
                                                            <Box component="span" sx={{ color: 'text.secondary' }}>{Lang('EMAIL')}: </Box>
                                                            {item.email}
                                                        </Typography>
                                                    }
                                                </Box>

                                            </Box>
                                        </Paper>
                                    ))
                                }
                            </Box>
                        }

                        {
                            !fetchBuscarGETData.loading && fetchBuscarGETData.data && items.length === 0 &&

                            <Box sx={{ textAlign: 'center', py: 3 }}>
                                <Typography variant='body2' sx={{ color: 'text.secondary' }}>
                                    {Lang('SIN_RESULTADOS')}
                                </Typography>
                            </Box>
                        }

                        {
                            personaSeleccionada &&

                            <Paper variant="outlined" className='p-3 mt-3'>

                                <Typography variant='subtitle1' className='fw-500 color-primary my-0 mb-2'>
                                    {Lang('DETALLE_PERSONA')}
                                </Typography>

                                <Grid container spacing={2}>

                                    <Grid item xs={12} sm={6}>
                                        <DetailField label={Lang('NOMBRE')} value={nombreCompleto(personaSeleccionada)} />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <DetailField label={Lang('NIF')} value={personaSeleccionada.nif} />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <DetailField label={Lang('EMAIL')} value={personaSeleccionada.email} />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <DetailField label={Lang('USUARIO')} value={personaSeleccionada.username} />
                                    </Grid>

                                </Grid>

                                <Box className='mt-4' sx={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>

                                    <FontAwesomeIcon icon={faUserCheck} className='color-primary' />

                                    <Button
                                        color="primary"
                                        variant="contained"
                                        size="medium"
                                        onClick={() => onAutorizar(personaSeleccionada)}
                                    >
                                        {Lang('ENVIAR_AUTORIZACION')}
                                    </Button>

                                </Box>

                                <Typography variant='body2' className='mt-2' sx={{ color: 'text.secondary', textAlign: 'center' }}>
                                    {Lang('PERSONA_RECIBIRA_SOLICITUD')}
                                </Typography>

                            </Paper>
                        }

                    </Grid>

                    <Grid item xs={12}>
                        <section className='ModalFooter border-0 d-flex justify-content-between mt-2'>
                            <div></div>
                            <Button size="small" variant="outlined" onClick={onClose}>
                                {Lang('CERRAR')}
                            </Button>
                        </section>
                    </Grid>
                </Grid>

            </Fade>
        </Modal>
    )
}